<div class="add-customer-root">
    <div class="ac-header">
        <button *ngIf="!isReadOnly" (click)="saveOrUpdate()" class="btn btn-primary"
            [ngClass]="saveDisabled ? 'btn btn-disabled' : '' ">Save</button>
        <button class="btn btn-cancel" (click)="cancelClicked()">{{ isReadOnly ? 'Close' : 'Cancel' }}</button>
        <button *ngIf="!isReadOnly && customer.id != 0" class="btn btn-assign" data-bs-toggle="modal"
            data-bs-target="#assignForDecommission">Assign for decommision</button>
    </div>
    <div class="ac-body section-line" [class.read-only-view]="isReadOnly"
        [ngClass]="activeCard === 4 ? 'section-line-last-active' : activeCard === 5 ? 'section-line-finished' : ''">
        <form ngNativeValidate id="card1Form" (submit)="continue()" class="card-1"
            [ngClass]="activeCard > 1 ? 'item-line' : ''">
            <div class="card-header">
                <div class="num" [ngClass]="(activeCard > 1) ? 'card-number-done' : ''">1</div>
                <div>Customer information</div>
                <div *ngIf="activeCard > 1" (click)="setActiveCard(1)">{{ isReadOnly ? 'View' : 'Edit' }}</div>
            </div>
            <div *ngIf="activeCard === 1">
                <div class="container card form-wrapper">
                    <div class="form-item form-floating mb-3">
                        <input [(ngModel)]="customer.buildingOwner" name="customerName" type="text" class="form-control"
                            id="floatingInput1" placeholder=" " required>
                        <label for="floatingInput1">Building owner/Account name</label>
                    </div>
                    <div class="row">
                        <div class="col-6 form-item form-floating mb-3">
                            <input [(ngModel)]="customer.accountNumber" name="accountNumber" type="text"
                                class="form-control" [class.is-invalid]="accountNumberInvalid" id="floatingInput2"
                                placeholder=" " [required]="customer.id===0" [readonly]="customer.id !== 0"
                                (blur)="onAccountNumberBlur()">
                            <label for="floatingInput2">Account number</label>
                            <div class="invalid-feedback" *ngIf="accountNumberInvalid">{{accountNumberErrorMessage}}
                            </div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" [hidden]="!isSpnFieldVisible">
                            <input [(ngModel)]="customer.spn" name="spn" type="text"
                                class="form-control non-required-field" [class.is-invalid]="spnInvalid"
                                id="floatingInput13" placeholder=" " pattern="[0-9]+" [readonly]="customer.id !== 0"
                                (blur)="onSpnBlur()">
                            <label for="floatingInput13">{{contractNumber}}</label>
                            <div class="invalid-feedback" *ngIf="spnInvalid">{{spnErrorMessage}}</div>
                        </div>


                    </div>
                    <div class="row">
                        <div class="col-6 form-item form-floating mb-3">
                            <input [(ngModel)]="customer.phoneNumber" name="phoneNumber" type="text"
                                class="form-control" id="floatingInput11" placeholder=" " pattern="[- +()0-9]+">
                            <label for="floatingInput11">Phone number</label>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <input [(ngModel)]="customer.email" name="emailAddress" type="email" class="form-control"
                                id="floatingInput10" placeholder=" ">
                            <label for="floatingInput10">Email address</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 form-item form-floating mb-3">
                            <input [(ngModel)]="customer.customerName" name="kycCustomerName" type="text"
                                class="form-control non-required-field" id="kycCustomerName" placeholder=" ">
                            <label for="kycCustomerName">{{ 'COMMON.CUSTOMER.KYC.CUSTOMER_NAME' | translate }}</label>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <input [(ngModel)]="customer.nin" name="kycNin" type="text"
                                class="form-control non-required-field" [class.is-invalid]="ninInvalid" id="kycNin"
                                placeholder=" " pattern="[0-9]{11}" maxlength="11">
                            <label for="kycNin">{{ 'COMMON.CUSTOMER.KYC.NIN' | translate }}</label>
                            <div class="invalid-feedback" *ngIf="ninInvalid">
                                {{ 'COMMON.CUSTOMER.KYC.NIN_INVALID' | translate }}</div>
                        </div>
                    </div>
                    <div class="row nin-image-row" *ngIf="ninChanged && !ninInvalid">
                        <div class="col-12 form-item mb-3">
                            <div class="nin-image-upload" [ngClass]="ninImageState">
                                <label class="nin-image-button" for="kycNinImage">
                                    <img src="assets/icons/upload-arrow.svg" alt="" />
                                    {{ 'COMMON.CUSTOMER.KYC.NIN_IMAGE_UPLOAD' | translate }}
                                </label>
                                <input type="file" id="kycNinImage" class="d-none" accept="image/png, image/jpeg"
                                    (change)="ninImageSelected($event)">
                                <span class="nin-image-name">{{ ninImageState === 'empty' ? ('COMMON.CUSTOMER.KYC.NIN_IMAGE' | translate) : ninImageName }}</span>
                                <img class="nin-image-status" *ngIf="ninImageState === 'pending'"
                                    src="assets/customer/loading-animation.svg" alt="" />
                                <img class="nin-image-status" *ngIf="ninImageState === 'valid'"
                                    src="assets/customer/circle-check.svg" alt="" />
                                <img class="nin-image-status" *ngIf="ninImageState === 'invalid'"
                                    src="assets/customer/x-circle.svg" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="customer.idType != null ? 'selected-option' : ''"
                                name="kycIdentificationType" [(ngModel)]="customer.idType"
                                class="form-select">
                                <option [ngValue]="undefined" disabled>{{ 'COMMON.CUSTOMER.KYC.ID_TYPE' | translate }}
                                </option>
                                <option *ngFor="let o of identificationTypeOptions" [ngValue]="o.value">
                                    {{ o.name | translate }}
                                </option>
                            </select>
                            <label *ngIf="customer.idType != null" class="label-for-select"
                                for="floatingSelect">{{ 'COMMON.CUSTOMER.KYC.ID_TYPE' | translate }}</label>
                            <div *ngIf="customer.idType != null" class="select-title"></div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <input [(ngModel)]="customer.idNumber" name="kycIdNumber" type="text"
                                class="form-control non-required-field" id="kycIdNumber" placeholder=" ">
                            <label for="kycIdNumber">{{ 'COMMON.CUSTOMER.KYC.ID_NUMBER' | translate }}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="customer.ownershipStatus != null ? 'selected-option' : ''"
                                name="kycOwnershipStatus" [(ngModel)]="customer.ownershipStatus" class="form-select">
                                <option [ngValue]="undefined" disabled>
                                    {{ 'COMMON.CUSTOMER.KYC.OWNERSHIP_STATUS' | translate }}</option>
                                <option *ngFor="let o of ownershipStatusOptions" [ngValue]="o.value">
                                    {{ o.name | translate }}
                                </option>
                            </select>
                            <label *ngIf="customer.ownershipStatus != null" class="label-for-select"
                                for="floatingSelect">{{ 'COMMON.CUSTOMER.KYC.OWNERSHIP_STATUS' | translate }}</label>
                            <div *ngIf="customer.ownershipStatus != null" class="select-title"></div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <input [(ngModel)]="customer.dateOfBirth" name="kycDateOfBirth" type="date"
                                class="form-control non-required-field" id="kycDateOfBirth" placeholder=" "
                                [max]="maxDateOfBirth">
                            <label for="kycDateOfBirth">{{ 'COMMON.CUSTOMER.KYC.DATE_OF_BIRTH' | translate }}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="mb-3 col-6">
                            <div class="dropdown searchable-dropdown">
                                <div class="label-top-left" *ngIf="customer.nationality">
                                    {{ 'COMMON.CUSTOMER.KYC.NATIONALITY' | translate }}</div>
                                <button class="btn searchable-button" [ngClass]="{'has-value': customer.nationality}"
                                    type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="value-text" *ngIf="!customer.nationality">
                                        {{ 'COMMON.CUSTOMER.KYC.NATIONALITY' | translate }}</span>
                                    <span class="value-text selected"
                                        *ngIf="customer.nationality">{{customer.nationality}}</span>
                                </button>
                                <ul class="dropdown-menu">
                                    <div class="search-input modal-multi-select-input">
                                        <img src="../../../../assets/icons/search.svg" alt="Search icon" />
                                        <input type="text" [placeholder]="'COMMON.SEARCH' | translate"
                                            [(ngModel)]="nationalityFilter" name="nationalityFilter"
                                            (input)="filterNationalityOptions()" click-stop-propagation />
                                    </div>
                                    <div class="dropdown-items">
                                        <label *ngFor="let n of filteredNationalities"
                                            (click)="selectNationalityOption(n)">
                                            <span>{{n.displayValue}}</span>
                                        </label>
                                    </div>
                                </ul>
                            </div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="customer.gender != null ? 'selected-option' : ''" name="kycGender"
                                [(ngModel)]="customer.gender" class="form-select">
                                <option [ngValue]="undefined" disabled>{{ 'COMMON.CUSTOMER.KYC.GENDER' | translate }}
                                </option>
                                <option *ngFor="let o of genderOptions" [ngValue]="o.value">
                                    {{ o.name | translate }}
                                </option>
                            </select>
                            <label *ngIf="customer.gender != null" class="label-for-select"
                                for="floatingSelect">{{ 'COMMON.CUSTOMER.KYC.GENDER' | translate }}</label>
                            <div *ngIf="customer.gender != null" class="select-title"></div>
                        </div>
                    </div>
                    <div class="form-item form-floating mb-3">
                        <input [(ngModel)]="customer.address" name="homeAddress" type="text" class="form-control"
                            id="floatingInput9" placeholder=" " required>
                        <label for="floatingInput9">Address</label>
                    </div>
                    <div class="row" *ngIf="!authService.hasCimDataIntegration">
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="region !== '' ? 'selected-option valid' : ''" name="region"
                                (change)="selectRegion($event)" required class="form-select">
                                <option value="" [selected]="region === ''" disabled>{{buName}}</option>
                                <option *ngFor="let o of regions" [selected]="region === o.name" value="{{o.id}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="region !== ''" class="label-for-select"
                                for="floatingSelect">{{buName}}</label>
                            <div *ngIf="region !== ''" class="select-title"></div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="area !== '' ? 'selected-option' : ''" name="area"
                                (change)="selectArea($event)" required class="form-select">
                                <option value="" [selected]="!customer.areaId" disabled>{{utName}}</option>
                                <option *ngFor="let o of selectableAreas" [selected]="area === o.name" value="{{o.id}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="area !== ''" class="label-for-select" for="floatingSelect">{{utName}}</label>
                            <div *ngIf="area !== ''" class="select-title"></div>
                        </div>
                    </div>
                    <div class="row" *ngIf="authService.hasCimDataIntegration">
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="selectedGeographicalRegionId ? 'selected-option valid' : ''"
                                name="geographicalRegion" (change)="selectGeographicalRegion($event)" required
                                class="form-select">
                                <option value="" [selected]="!selectedGeographicalRegionId" disabled>{{buName}}</option>
                                <option *ngFor="let o of geoRegions" [selected]="selectedGeographicalRegionId === o.id"
                                    value="{{o.id}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="selectedGeographicalRegionId" class="label-for-select"
                                for="floatingSelect">{{buName}}</label>
                            <div *ngIf="selectedGeographicalRegionId" class="select-title"></div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="customer.subgeographicalRegionId ? 'selected-option' : ''"
                                name="subGeographicalRegion" (change)="selectSubGeographicalRegion($event)" required
                                class="form-select">
                                <option value="" [selected]="!customer.subgeographicalRegionId" disabled>{{utName}}
                                </option>
                                <option *ngFor="let o of selectableSubGeoRegions"
                                    [selected]="customer.subgeographicalRegionId === o.id" value="{{o.id}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="customer.subgeographicalRegionId" class="label-for-select"
                                for="floatingSelect">{{utName}}</label>
                            <div *ngIf="customer.subgeographicalRegionId" class="select-title"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="buildingType !== '' ? 'selected-option' : ''" name="buildingType"
                                (change)="selectBuildingType($event)" class="form-select">
                                <option value="" [selected]="buildingType === ''" disabled>Use of premises</option>
                                <option *ngFor="let o of buildingTypeOptions" [selected]="buildingType === o.name"
                                    value="{{o.value}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="buildingType !== ''" class="label-for-select" for="floatingSelect">Use of
                                permises</label>
                            <div *ngIf="buildingType !== ''" class="select-title"></div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="typeOfConnection !== '' ? 'selected-option' : ''" name="typeOfConnection"
                                (change)="selectCustomerPhase($event)" class="form-select">
                                <option value="" [selected]="typeOfConnection === ''" disabled>Customer phase</option>
                                <option *ngFor="let o of customerPhaseOptions" [selected]="typeOfConnection === o.name"
                                    value="{{o.value}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="typeOfConnection !== ''" class="label-for-select"
                                for="floatingSelect">Customer phase</label>
                            <div *ngIf="typeOfConnection !== ''" class="select-title"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-item form-floating mb-3"
                            [ngClass]="isServiceTypeFieldVisible ? 'col-6' : 'col-12'">
                            <select [ngClass]="clientType !== '' ? 'selected-option' : ''" name="buildingType"
                                (change)="selectClientType($event)" class="form-select">
                                <option value="" [selected]="clientType === ''" disabled>Client type</option>
                                <option *ngFor="let o of clientTypeOptions" [selected]="clientType === o.name"
                                    value="{{o.value}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="clientType !== ''" class="label-for-select" for="floatingSelect">Client
                                type</label>
                            <div *ngIf="clientType !== ''" class="select-title"></div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="customerType !== '' ? 'selected-option' : ''" name="customerType"
                                (change)="selectCustomerType($event)" required class="form-select">
                                <option value="" [selected]="customerType === ''" disabled>Customer type</option>
                                <option *ngFor="let o of customerTypeOptions" [selected]="customerType === o.name"
                                    value="{{o.value}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="customerType !== ''" class="label-for-select" for="floatingSelect">Customer
                                type</label>
                            <div *ngIf="customerType !== ''" class="select-title"></div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="selectedSltStatus.key !== 0 ? 'selected-option' : ''" name="sltStatus"
                                id="title" #title="ngModel" [(ngModel)]="selectedSltStatus" class="form-select"
                                [compareWith]="compareByKey" (ngModelChange)="filterTariffsByCriteria()">
                                <option [selected]="selectedSltStatus.key === 0" disabled [value]="title"> {{sltStatus}}
                                </option>
                                <option *ngFor="let option of sltOptions" [ngValue]="option"
                                    [selected]="selectedSltStatus.key === option.key">
                                    {{option.value}}
                                </option>
                            </select>
                            <label *ngIf="selectedSltStatus.key !== 0" class="label-for-select"
                                for="floatingSelect">{{sltStatus}}</label>
                            <div *ngIf="selectedSltStatus.key !== 0" class="select-title"></div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" [hidden]="!isServiceTypeFieldVisible">
                            <select [ngClass]="serviceType !== '' ? 'selected-option' : ''" name="serviceType"
                                (change)="selectServiceType($event)" class="form-select">
                                <option value="" [selected]="serviceType === ''" disabled>Service type</option>
                                <option *ngFor="let o of serviceTypeOptions" [selected]="serviceType === o.name"
                                    value="{{o.value}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="serviceType !== ''" class="label-for-select" for="floatingSelect">Service
                                type</label>
                            <div *ngIf="serviceType !== ''" class="select-title"></div>
                        </div>


                    </div>
                    <div class="row">
                        <div class="col-6 form-item form-floating mb-3" [hidden]="!isBlockNumberFieldVisible">
                            <input [(ngModel)]="customer.blockNumber" name="blockNumber" type="number" max="2147483647"
                                min="-2147483647" class="form-control non-required-field" id="floatingInput5"
                                placeholder=" " pattern="[0-9]+">
                            <label for="floatingInput5">Block number</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 form-item form-floating mb-3" [hidden]="!isGeoCodeFieldVisible">
                            <input [(ngModel)]="customer.geoCode" name="geoCode" type="number"
                                class="form-control non-required-field" id="floatingInput6" placeholder=" ">
                            <label for="floatingInput3">Geo code</label>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" [hidden]="!isActivityCodeFieldVisible">
                            <input [(ngModel)]="customer.activityCode" name="activityCode" type="text"
                                class="form-control non-required-field" id="floatingInput4" placeholder=" ">
                            <label for="floatingInput6">Activity code</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 form-item form-floating mb-3" [hidden]="!isCurrentPlotFieldVisible">
                            <input [(ngModel)]="customer.currentPlotCode" name="currentPlotCode" type="text"
                                class="form-control non-required-field" id="floatingInput7" placeholder=" ">
                            <label for="floatingInput7">Current Plot Code</label>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" [hidden]="!isGhanaPostFieldsVisible">
                            <input [(ngModel)]="customer.ghanaPostGPS" name="ghanaPostGPS" type="text"
                                class="form-control non-required-field" id="floatingInput8" placeholder=" ">
                            <label for="floatingInput8">Ghana post GPS</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="mb-3 col-6">
                            <div class="dropdown searchable-dropdown">
                                <div class="label-top-left" *ngIf="customer.tariffId != null">Tariff</div>
                                <button class="btn searchable-button"
                                    [ngClass]="{'has-value': customer.tariffId != null}" type="button"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="value-text" *ngIf="customer.tariffId == null">Tariff</span>
                                    <span class="value-text selected"
                                        *ngIf="customer.tariffId != null">{{tariff}}</span>
                                </button>
                                <ul class="dropdown-menu">
                                    <div class="search-input modal-multi-select-input">
                                        <img src="../../../../assets/icons/search.svg" alt="Search icon" />
                                        <input type="text" placeholder="Search" [(ngModel)]="tariffFilter"
                                            name="tariffFilter" (input)="filterTariffOptions()"
                                            click-stop-propagation />
                                    </div>
                                    <div class="dropdown-items">
                                        <label *ngFor="let t of filteredTariffs" (click)="selectTariffOption(t)">
                                            <span>{{t.name}}</span>
                                        </label>
                                    </div>
                                </ul>
                            </div>
                        </div>

                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="accountStatus !== '' ? 'selected-option' : ''" name="accountStatus"
                                (change)="selectAccountStatus($event)" class="form-select">
                                <option value="" [selected]="accountStatus === ''" disabled>Account status</option>
                                <option *ngFor="let o of accountStatusOptions" [selected]="accountStatus === o.name"
                                    value="{{o.value}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="accountStatus !== ''" class="label-for-select" for="floatingSelect">Account
                                status</label>
                            <div *ngIf="accountStatus !== ''" class="select-title"></div>
                        </div>

                    </div>
                </div>
                <div class="btn-continue-container">
                    <button class="btn btn-continue" form="card1Form"
                        [attr.formnovalidate]="isReadOnly ? '' : null">Continue</button>
                </div>
            </div>
            <div *ngIf="activeCard > 1" class="filled-card">
                <div class="container card">
                    <div class="row">
                        <div class="col-6">Building owner/Account name: {{customer.buildingOwner}}</div>
                        <div class="col-6">Customer type: {{customer.customerType}}</div>
                    </div>
                    <div class="row">
                        <div class="col-6">Phone number: {{customer.phoneNumber}}</div>
                        <div class="col-6">Email address: {{customer.email}}</div>
                    </div>
                    <div class="row">
                        <div class="col-12">Address: {{customer.address}}</div>
                    </div>
                </div>
            </div>
        </form>

        <form ngNativeValidate id="card2Form" (submit)="continue()" class="card-2 item"
            [ngClass]="activeCard > 2 ? 'item-line' : ''">
            <div class="card-header">
                <diV class="num"
                    [ngClass]="(activeCard < 2) ? 'card-number-gray' : (activeCard > 2) ? 'card-number-done' : '' ">2
                </diV>
                <div [ngClass]="(activeCard < 2) ? 'title-gray' : '' "> Feeder & DT Information</div>
                <div *ngIf="activeCard > 2" (click)="setActiveCard(2)">{{ isReadOnly ? 'View' : 'Edit' }}</div>
            </div>
            <div *ngIf="activeCard === 2">
                <div class="container card form-wrapper">
                    <ng-container *ngIf="!authService.hasCimDataIntegration">
                        <div class="form-item form-floating mb-3">
                            <select [ngClass]="feederType !== -1 ? 'selected-option' : ''" name="selectFeeder"
                                (change)="selectFeederType($event)" class="form-select">
                                <option value="" [selected]="feederType === -1" disabled>Feeder type</option>
                                <option value="KV11" [selected]="feederType === 0">11KV</option>
                                <option value="KV33" [selected]="feederType === 1">33KV</option>
                            </select>
                            <label *ngIf="feederType !== -1" class="label-for-select" for="floatingSelect">Feeder
                                type</label>
                            <div *ngIf="feederType !== -1" class="select-title"></div>
                        </div>
                        <div class="mb-3">
                            <div class="dropdown searchable-dropdown">
                                <div class="label-top-left" *ngIf="selectedFeederId !== 0">Feeder</div>
                                <button class="btn searchable-button" [ngClass]="{'has-value': selectedFeederId !== 0}"
                                    type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="value-text" *ngIf="selectedFeederId === 0">Feeder</span>
                                    <span class="value-text selected"
                                        *ngIf="selectedFeederId !== 0">{{selectedFeederName}}</span>
                                </button>
                                <ul class="dropdown-menu">
                                    <div class="search-input modal-multi-select-input">
                                        <img src="../../../../assets/icons/search.svg" alt="Search icon" />
                                        <input type="text" placeholder="Search" [(ngModel)]="feederFilter"
                                            name="feederFilter" (input)="filterFeederOptions()"
                                            click-stop-propagation />
                                    </div>
                                    <div class="dropdown-items">
                                        <label *ngFor="let f of filteredFeeders" (click)="selectFeederOption(f)">
                                            <span>{{f.name}}</span>
                                        </label>
                                    </div>
                                </ul>
                            </div>
                        </div>
                        <div class="form-item form-floating mb-3">
                            <input [ngClass]="selectedDt.connectedFeederNumber.length > 0 ? 'filled-input' : ''"
                                [(ngModel)]="selectedDt.connectedFeederNumber" name="feederNumber" type="text"
                                class="form-control" id="floatingInput2" placeholder=" " required disabled>
                            <label for="floatingInput2">Feeder number</label>
                        </div>

                        <div class="mb-3">
                            <div class="dropdown searchable-dropdown">
                                <div class="label-top-left" *ngIf="selectedDt.externalId !== 0">DT name</div>
                                <button class="btn searchable-button"
                                    [ngClass]="{'has-value': selectedDt.externalId !== 0}" type="button"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="value-text" *ngIf="selectedDt.externalId === 0">DT name</span>
                                    <span class="value-text selected"
                                        *ngIf="selectedDt.externalId !== 0">{{selectedDt.name}}</span>
                                </button>
                                <ul class="dropdown-menu">
                                    <div class="search-input modal-multi-select-input">
                                        <img src="../../../../assets/icons/search.svg" alt="Search icon" />
                                        <input type="text" placeholder="Search" [(ngModel)]="dtFilter" name="dtFilter"
                                            (input)="filterDtOptions()" click-stop-propagation />
                                    </div>
                                    <div class="dropdown-items">
                                        <label *ngFor="let dt of filteredDts" (click)="selectDtOption(dt)">
                                            <span>{{dt.name}}</span>
                                        </label>
                                    </div>
                                </ul>
                            </div>
                        </div>
                        <div class="form-item form-floating mb-3">
                            <input [ngClass]="selectedDt.number.length > 0 ? 'filled-input' : ''"
                                [(ngModel)]="selectedDt.number" name="dtNumber" type="text" class="form-control"
                                id="floatingInput2" placeholder=" " required disabled>
                            <label for="floatingInput2">{{ dtName }}</label>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="authService.hasCimDataIntegration">
                        <div class="form-item form-floating mb-3">
                            <select [ngClass]="selectedVoltageClass ? 'selected-option' : ''" name="voltageClass"
                                (change)="selectVoltageClass($event)" class="form-select">
                                <option value="" [selected]="!selectedVoltageClass" disabled>Feeder type</option>
                                <option *ngFor="let o of voltageClassOptions"
                                    [selected]="selectedVoltageClass === o.value" value="{{o.value}}">{{o.name}}
                                </option>
                            </select>
                            <label *ngIf="selectedVoltageClass" class="label-for-select" for="floatingSelect">Feeder
                                type</label>
                            <div *ngIf="selectedVoltageClass" class="select-title"></div>
                        </div>
                        <div class="mb-3">
                            <div class="dropdown searchable-dropdown">
                                <div class="label-top-left" *ngIf="selectedAcLineId !== 0">Feeder</div>
                                <button class="btn searchable-button" [ngClass]="{'has-value': selectedAcLineId !== 0}"
                                    type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <span class="value-text" *ngIf="selectedAcLineId === 0">Feeder</span>
                                    <span class="value-text selected"
                                        *ngIf="selectedAcLineId !== 0">{{selectedAcLineName}}</span>
                                </button>
                                <ul class="dropdown-menu">
                                    <div class="search-input modal-multi-select-input">
                                        <img src="../../../../assets/icons/search.svg" alt="Search icon" />
                                        <input type="text" placeholder="Search" [(ngModel)]="acLineFilter"
                                            name="acLineFilter" (input)="filterAcLineOptions()"
                                            click-stop-propagation />
                                    </div>
                                    <div class="dropdown-items">
                                        <label *ngFor="let l of filteredAcLines" (click)="selectAcLineOption(l)">
                                            <span>{{l.name}}</span>
                                        </label>
                                    </div>
                                </ul>
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="dropdown searchable-dropdown">
                                <div class="label-top-left" *ngIf="customer.substationId">DT name</div>
                                <button class="btn searchable-button" [ngClass]="{'has-value': customer.substationId}" type="button" data-bs-toggle="dropdown" aria-expanded="false" [disabled]="!selectedVoltageClass">
                                    <span class="value-text" *ngIf="!customer.substationId">DT name</span>
                                    <span class="value-text selected"
                                        *ngIf="customer.substationId">{{selectedSubstationName}}</span>
                                </button>
                                <ul class="dropdown-menu">
                                    <div class="search-input modal-multi-select-input">
                                        <img src="../../../../assets/icons/search.svg" alt="Search icon" />
                                        <input type="text" placeholder="Search" [(ngModel)]="substationFilter"
                                            name="substationFilter" (input)="filterSubstationOptions()"
                                            click-stop-propagation />
                                    </div>
                                    <div class="dropdown-items">
                                        <label *ngFor="let s of filteredSubstations"
                                            (click)="selectSubstationOption(s)">
                                            <span>{{s.name}}</span>
                                        </label>
                                    </div>
                                </ul>
                            </div>
                        </div>
                        <div class="form-item form-floating mb-3">
                            <input [ngClass]="selectedSubstationNumber.length > 0 ? 'filled-input' : ''"
                                [value]="selectedSubstationNumber" name="substationNumber" type="text"
                                class="form-control" placeholder=" " required disabled>
                            <label>{{ dtName }}</label>
                        </div>
                    </ng-container>
                </div>
                <div class="btn-continue-container">
                    <button class="btn btn-continue" form="card2Form"
                        [attr.formnovalidate]="isReadOnly ? '' : null">Continue</button>
                </div>
            </div>
            <div *ngIf="activeCard > 2" class="filled-card">
                <div class="container card" *ngIf="!authService.hasCimDataIntegration">
                    <div class="row">
                        <div class="col-6">Tariff: {{ customer.tariffId != null ? getTariffName(customer.tariffId) : ''
                            }}</div>
                        <div class="col-6">DS name: {{selectedDt.name}}</div>
                    </div>
                    <div class="row">
                        <div class="col-6">{{ dtName }}: {{selectedDt.number}}</div>
                        <div class="col-6">Feeder: {{selectedDt.connectedFeederNumber}}</div>
                    </div>
                </div>
                <div class="container card" *ngIf="authService.hasCimDataIntegration">
                    <div class="row">
                        <div class="col-6">Tariff: {{ customer.tariffId != null ? getTariffName(customer.tariffId) : ''
                            }}</div>
                        <div class="col-6">DS name: {{selectedSubstationName}}</div>
                    </div>
                    <div class="row">
                        <div class="col-6">{{ dtName }}: {{selectedSubstationNumber}}</div>
                        <div class="col-6">Feeder: {{selectedAcLineName}}</div>
                    </div>
                </div>
            </div>
        </form>

        <form ngNativeValidate id="card3Form" (submit)="continue()" class="card-3 item"
            [ngClass]="activeCard > 3 ? 'item-line' : ''">
            <div class="card-header">
                <diV class="num"
                    [ngClass]="(activeCard < 3) ? 'card-number-gray' : (activeCard > 3) ? 'card-number-done' : '' ">3
                </diV>
                <div [ngClass]="(activeCard < 3) ? 'title-gray' : '' ">Meter information</div>
                <div *ngIf="activeCard > 3" (click)="setActiveCard(3)">{{ isReadOnly ? 'View' : 'Edit' }}</div>
            </div>
            <div *ngIf="activeCard === 3">
                <div class="container card form-wrapper">
                    <div class="form-item form-floating mb-3">
                        <select [ngClass]="meterStatus !== '' ? 'selected-option' : ''"
                            (change)="selectMeterStatus($event)" name="meterStatus" required class="form-select">
                            <option value="" [selected]="meterStatus === ''" disabled>Meter status</option>
                            <option *ngFor="let o of meterStatusOptions" [selected]="meterStatus === o.name"
                                value="{{o.value}}">
                                {{o.name}}
                            </option>
                        </select>
                    </div>
                    <div class="row" *ngIf="meterStatus === 'Metered'">
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="meterType !== '' ? 'selected-option' : ''"
                                (change)="selectMeterType($event)" name="meterType" required class="form-select">
                                <option value="" [selected]="meterType === ''" disabled>Meter type</option>
                                <option *ngFor="let o of meterTypes" [selected]="meterType=== o.name" value="{{o.id}}">
                                    {{o.name}}
                                </option>
                            </select>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="billingType !== '' ? 'selected-option' : ''"
                                (change)="selectBillingType($event)" name="billingType" disabled  class="form-select">
                                <option value="" [selected]="billingType === ''" disabled>Customer type</option>
                                <option *ngFor="let o of billingTypeOptions" [selected]="billingType === o.name"
                                    value="{{o.value}}">
                                    {{o.name}}
                                </option>
                            </select>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" *ngIf="meterStatus === 'Metered'">
                            <select [ngClass]="meterCondition !== '' ? 'selected-option' : ''"
                                (change)="selectMeterCondition($event)" name="meterCondition" required
                                class="form-select">
                                <option value="" [selected]="meterCondition === ''" disabled>Meter condition</option>
                                <option *ngFor="let o of meterConditionOptions" [selected]="meterCondition === o.name"
                                    value="{{o.value}}">
                                    {{o.name}}
                                </option>
                            </select>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" *ngIf="meterStatus === 'Metered'">
                            <input [(ngModel)]="customer.meter.number" name="meterNumber" type="text"
                                class="form-control" id="floatingInput2" placeholder=" " required>
                            <label for="floatingInput2">Meter number</label>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" *ngIf="meterStatus === 'Metered'">
                            <input [(ngModel)]="customer.meter.tariffIndex" name="tariffIndex" type="number"
                                class="form-control" id="floatingInput3" placeholder=" " min="1" max="99">
                            <label for="floatingInput3">Tariff Index</label>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" *ngIf="meterStatus === 'Metered'">
                            <select [ngClass]="customer.meter.meterModelId ? 'selected-option' : ''"
                                (change)="selectMeterModel($event)" name="meterModel" class="form-select">
                                <option value="" [selected]="!customer.meter.meterModelId" disabled>
                                    {{ "COMMON.MBC_DETAILS.METER_MODEL.SINGLE" | translate }}
                                </option>
                                <option *ngFor="let o of selectableMeterModels"
                                    [selected]="customer.meter.meterModelId === o.id" value="{{o.id}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="customer.meter.meterModelId" class="label-for-select"
                                for="floatingInput4">Meter Model</label>
                            <div *ngIf="customer.meter.meterModelId" class="select-title"></div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3">
                            <select [ngClass]="customer.meter.compatibility3KCT != undefined ? 'selected-option' : ''"
                                (change)="select3kctCompatibility($event)" name="compatibility3KCT" class="form-select">
                                <option value="" [selected]="customer.meter.compatibility3KCT == undefined" disabled>
                                    3KCT Compatibility
                                </option>
                                <option *ngFor="let o of compatilibity3kctOptions"
                                    [selected]="customer.meter.compatibility3KCT === o.value" value="{{o.value}}">
                                    {{o.name}}
                                </option>
                            </select>
                            <label *ngIf="customer.meter.compatibility3KCT != undefined" class="label-for-select"
                                for="floatingSelect">3KCT Compatibility</label>
                            <div *ngIf="customer.meter.compatibility3KCT != undefined" class="select-title"></div>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" *ngIf="meterStatus === 'Metered'">
                            <input [(ngModel)]="customer.meter.krn" name="krn" type="number" class="form-control"
                                id="floatingInput6" placeholder=" " min="1" max="99">
                            <label for="floatingInput6">KRN</label>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" *ngIf="meterStatus === 'Metered'">
                            <input [(ngModel)]="customer.meter.sgc" name="sgc" type="text" class="form-control"
                                id="floatingInput7" placeholder=" " pattern="[0-9]*" minlength="6" maxlength="6"
                                inputmode="numeric">
                            <label for="floatingInput7">SGC</label>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" *ngIf="meterStatus === 'Metered'">
                            <input [(ngModel)]="customer.meter.ken" name="ken" type="number" class="form-control"
                                id="floatingInput8" placeholder=" " min="1" max="255">
                            <label for="floatingInput8">KEN</label>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" *ngIf="meterStatus === 'Metered'">
                            <input [(ngModel)]="customer.installationDate" name="installationDate" type="date"
                                class="form-control non-required-field" id="installationDate" placeholder=" ">
                            <label for="installationDate">Installation Date</label>
                        </div>
                        <div class="col-6 form-item form-floating mb-3 old-meter-number" *ngIf="customer.id !== 0">
                            <input [value]="customer.oldMeterNumber || ''" type="text" class="form-control"
                                id="oldMeterNumber" placeholder=" " readonly>
                            <label for="oldMeterNumber">Old Meter Number</label>
                            <button *ngIf="customer.oldMeterNumber" type="button" class="btn availability-button"
                                [disabled]="customer.oldMeterIsMadeAvailable" data-bs-toggle="modal" data-bs-target="#oldMeterAvailability"
                                [title]="'COMMON.OLD_METER_AVAILABILITY.AVAILABILITY' | translate">
                                <img src="../../../../assets/icons/unarchive.svg" alt="Availability icon" />
                            </button>
                        </div>
                        <div class="col-6 form-item form-floating mb-3" *ngIf="customer.id !== 0">
                            <input [value]="customer.oldMeterBrand || ''" type="text" class="form-control"
                                id="oldMeterBrand" placeholder=" " readonly>
                            <label for="oldMeterBrand">Old Meter Brand</label>
                        </div>
                    </div>


                </div>
                <div class="btn-continue-container">
                    <button class="btn btn-continue" form="card3Form"
                        [attr.formnovalidate]="isReadOnly ? '' : null">Continue</button>
                </div>
            </div>
            <div *ngIf="activeCard > 3" class="filled-card">
                <div class="container card">
                    <div class="row">
                        <div class="col-6 p-1">Meter type: {{getMeterTypeName(customer.meter.typeId)}}</div>
                        <div class="col-6 p-1">Meter status: {{MeterStatus[customer.meter.status]}}</div>
                        <div class="col-6 p-1">Meter condition: {{MeterCondition[customer.meter.condition]}}</div>
                        <div class="col-6 p-1">Meter number: {{customer.meter.number}}</div>
                        <div *ngIf="customer.id !== 0" class="col-6 p-1">Old Meter Number: {{customer.oldMeterNumber}}
                        </div>
                        <div *ngIf="customer.id !== 0" class="col-6 p-1">Old Meter Brand: {{customer.oldMeterBrand}}
                        </div>
                        <div class="col-6 p-1">Tariff Index: {{customer.meter.tariffIndex}}</div>
                        <div class="col-6 p-1">Meter Model: {{getMeterModelName(customer.meter.meterModelId)}}</div>
                        <div *ngIf="customer.meter.compatibility3KCT != undefined" class="col-6 p-1">3KCT Compatibility:
                            {{ customer.meter.compatibility3KCT ? 'Yes' : 'No' }}</div>
                        <div class="col-6 p-1">KRN: {{customer.meter.krn}}</div>
                        <div class="col-6 p-1">SGC: {{customer.meter.sgc}}</div>
                        <div class="col-6 p-1">KEN: {{customer.meter.ken}}</div>
                        <div class="col-6 p-1">Installation Date: {{customer.installationDate}}</div>
                    </div>
                </div>
            </div>
        </form>

        <div class="card-4 item">
            <div class="card-header">
                <diV class="num"
                    [ngClass]="(activeCard < 3) ? 'card-number-gray' : (activeCard > 3) ? 'card-number-done' : '' ">4
                </diV>
                <div [ngClass]="(activeCard < 3) ? 'title-gray' : '' ">{{'COMMON.CUSTOMER.STATUS' | translate }}</div>
            </div>
            <div *ngIf="activeCard === 4" class="filled-card">
                <div class="container card">
                    <div class="row">
                        <div class="col-6">Accessibility Status: {{customer.buildingId ? "Completed" : "Pending Setup"}}
                        </div>
                        <div class="col-6">Survey Status: {{customer.surveyStatus}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="successfull-toast" *ngIf="successfullyAdded">
        <div class="img-container"><img src="../../../../assets/icons/checked_green.svg" alt="Checked icon" /></div>
        <div class="text-container">
            <div>Added</div>
            <div>New customer has been added</div>
        </div>
        <div class="x-container"><img src="../../../../assets/icons/close.svg" alt="Close icon" /></div>
    </div>
</div>
<button class="btn btn-primary" #openUpdateDescriptionModal data-bs-toggle="modal" data-bs-target="#history"
    hidden></button>
<app-history (update)="updateHistory($event)"></app-history>

<div class="modal fade" id="assignForDecommission" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Assign to field agent</h5>
                <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
                    Cancel
                </button>
            </div>
            <div class="modal-body">
                <div class="form-floating form-item">

                    <input #userFilterInput autocomplete="off" type="text" name="filterText" [(ngModel)]="filterText"
                        class="form-control filter-field" [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }"
                        id="floatingInput" (ngModelChange)="filterMobileUsers()" (click)="isDropdownOpened = true"
                        placeholder=" " />
                    <label for="floatingInput">Field agent</label>

                    <div class="filtered-agent-list" *ngIf="isDropdownOpened" #dropdownContainer>
                        <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)"
                            *ngFor="let u of mobileUsers">
                            {{ u.fullName }}
                        </div>
                    </div>

                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                    data-bs-target="#assignForDecommissionSuccess" (click)="assignForDecommission()">
                    <span data-bs-dismiss="modal">Assign task</span>
                </button>
            </div>
        </div>
    </div>
</div>









<div class="modal fade" id="assignForDecommissionSuccess" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Assign to decommision successfull</h5>
                <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
                    Cancel
                </button>
            </div>
            <div class="modal-body">
                Task successfully assigned for Decommissioning.
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
                    <span>Ok</span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="oldMeterAvailability" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'COMMON.OLD_METER_AVAILABILITY.AVAILABILITY' | translate }}</h5>
                <button type="button" class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
                    {{ 'COMMON.CANCEL' | translate }}
                </button>
            </div>
            <div class="modal-body">
                {{ 'COMMON.OLD_METER_AVAILABILITY.PROMPT' | translate }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                    (click)="makeOldMeterAvailable()">
                    <span>{{ 'COMMON.OLD_METER_AVAILABILITY.PROCEED' | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>
